module.exports = __webpack_public_path__ + "logo_christopheds.svg?462cd86b4ab9fff108027367bbc1fecc";


//////////////////
// WEBPACK FOOTER
// ./src/img/footer/logo_christopheds.svg
// module id = 184
// module chunks = 0